export const HOME_PAGE = {
  startTrainingButton: "home-start-training-button",
  introVideoPlaceholder: "home-intro-video-placeholder",
};

export const TRAINING = {
  moduleCard: (id) => `training-module-card-${id}`,
  moduleLockedBadge: (id) => `training-module-locked-badge-${id}`,
  playButton: (id) => `training-module-play-button-${id}`,
  markCompleteButton: (id) => `training-module-complete-button-${id}`,
  completedBadge: (id) => `training-module-completed-badge-${id}`,
  continueToCertificateButton: "training-continue-to-certificate-button",
  progressBar: "training-overall-progress-bar",
};

export const MODULE_QUIZ = {
  container: (moduleId) => `module-quiz-container-${moduleId}`,
  optionRadio: (moduleId, qid, opt) => `module-quiz-option-${moduleId}-${qid}-${opt}`,
  submitButton: (moduleId) => `module-quiz-submit-${moduleId}`,
  retryButton: (moduleId) => `module-quiz-retry-${moduleId}`,
  passedMessage: (moduleId) => `module-quiz-passed-${moduleId}`,
  failedMessage: (moduleId) => `module-quiz-failed-${moduleId}`,
  continueButton: (moduleId) => `module-quiz-continue-${moduleId}`,
};

export const PRODUCT_GUIDE = {
  catalogueButton: "denso-catalogue-open-button",
  youtubeCard: (id) => `product-guide-youtube-card-${id}`,
  youtubeIframe: (id) => `product-guide-youtube-iframe-${id}`,
};

export const CERTIFICATE = {
  container: "certificate-container",
  downloadButton: "certificate-download-button",
  backButton: "certificate-back-button",
};

export const ADMIN = {
  emailInput: "admin-login-email-input",
  passwordInput: "admin-login-password-input",
  loginButton: "admin-login-submit-button",
  errorMessage: "admin-login-error-message",
  logoutButton: "admin-logout-button",
  exportDatabaseButton: "admin-export-database-button",
  exportAllCertificatesButton: "admin-export-all-certificates-button",
  exportMysqlDumpButton: "admin-export-mysql-dump-button",
  statCard: (key) => `admin-stat-card-${key}`,
  participantRow: (id) => `admin-participant-row-${id}`,
  viewAttemptsButton: (id) => `admin-view-attempts-button-${id}`,
  backButton: "admin-back-button",
  attemptCard: (id) => `admin-attempt-card-${id}`,
  filterSelect: "admin-participants-filter-select",
  certDownloadedBadge: (id) => `admin-cert-downloaded-badge-${id}`,
  moduleStatRow: (id) => `admin-module-stat-row-${id}`,
};
